import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import { getAllWorkingStatusesEndpoint } from "~/modules/project/api/workingStatus/workingStatusApiEndpoints.ts";
import type { WorkingStatusType } from "~/modules/project/api/workingStatus/workingStatusTypes.ts";

export const getAllWorkingStatuses = (): AxiosApiResponsePromise<WorkingStatusType[]> => axiosApi.get(getAllWorkingStatusesEndpoint);
